import TimelineMax from 'TimelineMax'
import { select } from "@assets/scripts/utils";

export default function () {
    let svg = select('.i3')[0]
    if(!svg) return
    svg = svg.contentDocument

    const crates1 = svg.querySelector('.crates1')
    const crates1tl = new TimelineMax()
    crates1tl.fromTo(crates1, 1, { x: '10' }, { x: '-11', ease: SteppedEase.config(5) }).repeat(-1)

    const crates2 = svg.querySelector('.crates2')
    const crates2tl = new TimelineMax()
    crates2tl.fromTo(crates2, 1, { x: '8' }, { x: '-8', ease: SteppedEase.config(3) }).repeat(-1)

    const h1top = svg.querySelector('.hand1top')
    const h1end = svg.querySelector('.hand1end')
    const h1toptl = new TimelineMax()
    TweenMax.set(h1top, { transformOrigin: '100% 50%' })

    h1toptl
        .add(() => {
            TweenMax.fromTo(h1end, 1, { y: '0' }, { y: 5, ease: SteppedEase.config(2) })
            TweenMax.fromTo(h1top, 1, { rotation: 0 }, { rotation: -7, ease: SteppedEase.config(2) })
        })
        .add(() => {
            TweenMax.to(h1end, 1, { y: '0', ease: SteppedEase.config(2) })
            TweenMax.to(h1top, 1, { rotation: 0, ease: SteppedEase.config(2) })
        }, 1)
        .repeatDelay(1)
        .repeat(-1)

    const h2top = svg.querySelector('.hand2top')
    const h2end = svg.querySelector('.hand2end')
    const h2tl = new TimelineMax()

    TweenMax.set(h2top, { transformOrigin: '100% 50%' })

    h2tl
        .delay(0.5)
        .add(() => {
            TweenMax.fromTo(h2end, 1, { y: 0 }, { y: 5, ease: SteppedEase.config(2) })
            TweenMax.fromTo(h2top, 1, { rotation: 0 }, { rotation: -7, ease: SteppedEase.config(2) })
        })
        .add(() => {
            TweenMax.to(h2end, 1, { y: 0, ease: SteppedEase.config(2) })
            TweenMax.to(h2top, 1, { rotation: 0, ease: SteppedEase.config(2) })
        }, 1)
        .repeatDelay(1)
        .repeat(-1)
}
